export enum KANBAN_ORDER_MODAL_TYPE {
  addToCart = 'addToCart',
  addToCartConfirm = 'addToCartConfirm',
  clearForm = 'clearForm',
  verify = 'verify',
}
